const { encrypt, digest, decrypt } = require('@/tool/crypto');
const { getCryptoType } = require('@/tool/profile');

export const requestCryptoMiddleware = config => {
  const cryptoType = getCryptoType();
  if (cryptoType) {
    const handler = cryptoType === 1 ? encrypt : digest;
    if (config.params) {
      // 根据加密规范约定，转为对象，将参数再包裹一次params
      config.params = {
        params: handler(JSON.stringify(config.params)),
      };
    }
    if (config.data) {
      // 文件上传类（参数与文件共同存在于FormData对象中）的，跳过加密过程；
      if (config.headers['Content-Type'] === 'multipart/form-data') return;
      // TODO: 是否对其他的方法有影响？是不是没有必要判断；
      if (typeof config.data === 'object') {
        // 加密后Axios会自动加入x-www-form-urlencoded content-type，为了让后台@RequestBody的Controller可以解析，需要重新设置一下json；
        config.headers['Content-Type'] = 'application/json;charset=utf-8';
      }
      config.data = handler(JSON.stringify(config.data));
    }
    // TODO: 针对md5摘要方式，其实可以考虑，将签名、时间戳等放到header，参数不加密正常发送；
    // TODO: get请求参数加密、生成摘要后可能会存在超出url长度的隐患？
  }

  // console.log('md5', digest(config.data));
  // console.log('request info', config.method, config);
};

export const responseCryptoMiddleware = response => {
  if (response.data.crypto === 1) {
    // 服务端对响应体进行了JSON字符串化处理，所以无论解密的数据是不是JSON格式，都应当JSON解析一下；
    // TODO: 字符串也被强制JSON化了一下，进行了一步多余的不符合常理的解析，有待优化；
    response.data.data = JSON.parse(decrypt(response.data.data));
  }
};

// 封装参考：https://my.oschina.net/Lady/blog/1814825
